// Self-hosted brand fonts (the Web CSP allows only same-origin assets).
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import '@fontsource/alexandria/500.css';
import '@fontsource/alexandria/600.css';
import '@fontsource/ibm-plex-sans-arabic/400.css';
import '@fontsource/ibm-plex-sans-arabic/500.css';
import '@fontsource/ibm-plex-sans-arabic/600.css';
import '@fontsource/ibm-plex-sans-arabic/700.css';
import { StrictMode } from 'react';
import './styles.css';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { browserApiClient } from './api/ApiClientProvider';
import { App, createQueryClient, routes } from './app/App';
import { preferredLocale } from './i18n/messages';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');
createRoot(root).render(
  <StrictMode>
    <App
      client={browserApiClient()}
      router={createBrowserRouter(routes)}
      queryClient={createQueryClient()}
      locale={preferredLocale(navigator.languages)}
    />
  </StrictMode>,
);
